import { request } from "~/shared/apis"
import type { PostAuthSignInRequest, PostAuthSignInResponse } from "~/features/sign-in/queries/dto"

/**
 * @description 로그인을 진행합니다.
 */

export const postAuthSignIn = ({ username, password }: PostAuthSignInRequest) => {
  return request.post<PostAuthSignInResponse>("/auth/signin", {
    username,
    password,
  })
}
